import { render, staticRenderFns } from "./issue-trade.vue?vue&type=template&id=369b9284&scoped=true&"
import script from "./issue-trade.vue?vue&type=script&lang=js&"
export * from "./issue-trade.vue?vue&type=script&lang=js&"
import style0 from "./issue-trade.vue?vue&type=style&index=0&id=369b9284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369b9284",
  null
  
)

export default component.exports